import { DEFAULT_ACCOUNT_MODAL_CALLER_IDENTIFIER } from '../../../../constants/modalNames';
import { createSelector } from '../../../../utilities';
import { ACCOUNT_MODAL_TABS } from '../../../../constants';

export const getAccountModalSelectedTab = state => state.accountModal.selectedTab;
export const getHeaderModal = state => state.header.modals;
export const getAccountModalTemporaryMessage = state => state.accountModal.temporaryMessage;
export const getAccountModalEmail = state => state.accountModal.email;

export const getAccountCreationCallerId = createSelector(
  getHeaderModal,
  headerModalDetails => headerModalDetails.createAccountDetails.callerIdentifier ?? DEFAULT_ACCOUNT_MODAL_CALLER_IDENTIFIER,
);

export const getEventDefinedAccountModalTitle = createSelector(
  getHeaderModal,
  headerModalDetails => headerModalDetails?.createAccountDetails?.modalTitle ?? '',
);

export const getEventingOnSuccess = createSelector(
  getHeaderModal,
  headerModalDetails => headerModalDetails?.createAccountDetails?.onSuccess ?? null
);

export const getEventingOnError = createSelector(
  getHeaderModal,
  headerModalDetails => headerModalDetails?.createAccountDetails?.onError ?? null
);

export const shouldShowSignInTab = createSelector(
  getAccountModalSelectedTab,
  accountModalSelectedTab => ACCOUNT_MODAL_TABS.signIn.name === accountModalSelectedTab.name
);

export const shouldShowCreateAccountTab = createSelector(
  getAccountModalSelectedTab,
  accountModalSelectedTab => ACCOUNT_MODAL_TABS.createAccount.name === accountModalSelectedTab.name
);

export const shouldShowForgotPasswordTab = createSelector(
  getAccountModalSelectedTab,
  accountModalSelectedTab => ACCOUNT_MODAL_TABS.forgotPassword.name === accountModalSelectedTab.name
);

export const shouldShowResetPasswordTab = createSelector(
  getAccountModalSelectedTab,
  accountModalSelectedTab => ACCOUNT_MODAL_TABS.resetPassword.name === accountModalSelectedTab.name
);

export const getForgotPasswordState = state => state.accountModal.forgotPassword;
export const getResetPasswordState = state => state.accountModal.resetPassword;
export const getIsCreateAccountLoading = state => state.accountModal.createAccount.isLoading;
export const getIsSignInLoading = state => state.accountModal.signIn.isLoading;
export const getSignInError = state => state.accountModal.signIn.error.message;
export const getCreateAccountError = state => state.accountModal.createAccount.error;
export const getIsResetPasswordLoading = state => state.accountModal.resetPassword.isLoading;
export const getResetPasswordError = state => state.accountModal.resetPassword.error;

export const getCreateAccountEmailError = createSelector(
  getCreateAccountError,
  createAccountError => {
    const { errorMessage = '' } = createAccountError;
    const emailError = createAccountError.Email || /email/i.test(errorMessage);
    const doesErrorExist = Boolean(emailError);
    const createAccountEmailError = doesErrorExist ? emailError : null;

    return createAccountEmailError;
  }
);

export const getCreateAccountZipError = createSelector(
  getCreateAccountError,
  createAccountError => {
    const { errorMessage = '', status = '' } = createAccountError;
    const doesErrorExist = status.includes('InvalidRequest') && errorMessage.includes('zip code');
    const createAccountZipError = doesErrorExist ? errorMessage : null;

    return createAccountZipError;
  }
);
